import MobileDetect from 'mobile-detect'

export default new MobileDetect(window.navigator.userAgent)
